module.exports = __webpack_public_path__ + "static/media/check1.9ae147c3.svg";